<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout v-if="!loading&&visibleKpis.length" row wrap>
            <v-flex v-for="kpi in visibleKpis" :key="kpi.key" v-bind:class="['xs12', kpiColumnClass]">
                <vue-plotly v-if="kpi.data" :white-mode="whiteMode" disable-responsive :data="kpi.data"
                            :layout="kpi.layout" :options="{}"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {getNotification} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from "moment";
    export default {
        props: {
            title: {type: String, default: "Total Issue Detected"},
            title2: {type: String, default: "New Issues"},
            title3: {type: String, default: "Acknowledged Issues"},
            title4: {type: String, default: "Pending Issues"},
            height: {type: Number, default: 240},
            dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
            severityFilter:{type:[Array,String],default: function (){return []}},
            topicFilter:{type:[Array,String],default: ''},
            showTotalIssues:{type:Boolean, default: true},
            showNewIssues:{type:Boolean, default: true},
            showAcknowledgedIssues:{type:Boolean, default: true},
            showPendingIssues:{type:Boolean, default: false},
        },
        components: {LoadingProgressBar,VuePlotly},
        computed: {
            visibleKpis() {
                return [
                    {key: 'totalIssues', show: this.showTotalIssues, data: this.data, layout: this.layout},
                    {key: 'newIssues', show: this.showNewIssues, data: this.data2, layout: this.layout2},
                    {key: 'acknowledgedIssues', show: this.showAcknowledgedIssues, data: this.data3, layout: this.layout3},
                    {key: 'pendingIssues', show: this.showPendingIssues, data: this.data4, layout: this.layout4},
                ].filter(x => x.show)
            },
            kpiColumnClass() {
                let count = this.visibleKpis.length
                if (count <= 1) {
                    return 'md12'
                }
                if (count === 2) {
                    return 'md6'
                }
                if (count === 3) {
                    return 'md4'
                }
                return 'md3'
            },
        },
        name: 'IssueSummaryWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                data2:null,
                data3:null,
                data4:null,
                layout:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout2:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout3:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout4:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            normalizeFilter(value) {
                if (!value) {
                    return []
                }
                let values = Array.isArray(value) ? value : String(value).split(',')
                return values.map(x => String(x).trim().toLowerCase()).filter(x => x !== '')
            },
            notificationMatchesFilters(notification) {
                let severityFilter = this.normalizeFilter(this.severityFilter)
                let topicFilter = this.normalizeFilter(this.topicFilter)
                let severity = notification.severity ? notification.severity.toLowerCase() : ''
                let topic = notification.topic ? notification.topic.toLowerCase() : ''
                return (severityFilter.length === 0 || severityFilter.includes(severity)) &&
                    (topicFilter.length === 0 || topicFilter.includes(topic))
            },
            refresh(){
                this.debounce(this.getData,500);
            },
            async getData(){
                if(this.dateRange){
                    this.loading=true
                    let notifResult = await getNotification({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        date_range:[this.dateRange.start,moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59"],
                    })
                    let rangeFaults = notifResult.result.filter(x=>x.topic!=="anomaly"&&!x.title.toLowerCase().startsWith("anomaly")&&this.notificationMatchesFilters(x))
                    let newIssues=rangeFaults.filter(x=>x.start_date>=this.dateRange.start).length
                    let ackIssues=rangeFaults.filter(x=>x.acknowledged&&moment(x.last_ack_date).format('YYYY-MM-DD HH:mm:ss')>=moment(this.dateRange.start).format('YYYY-MM-DD HH:mm:ss')&&moment(x.last_ack_date).format('YYYY-MM-DD HH:mm:ss')<=moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59").length
let pendingIssues=rangeFaults.filter(x=>!x.acknowledged).length
                    this.data=[{
                        type:"indicator",
                        value:rangeFaults.length,
                        mode:"number",
                        title:{
                            text:this.title
                        }
                    }]
                    this.data2=[{
                        type:"indicator",
                        value:newIssues,
                        mode:"number",
                        title:{
                            text:this.title2
                        }
                    }]
                    this.data3=[{
                        type:"indicator",
                        value:ackIssues,
                        mode:"number",
                        title:{
                            text:this.title3
                        }
                    }]
                    this.data4=[{
                        type:"indicator",
                        value:pendingIssues,
                        mode:"number",
                        title:{
                            text:this.title4
                        }
                    }]
                    this.loading=false
                }
            }
        },
    }
</script>
